import { createSlice } from "@reduxjs/toolkit";
const initialState =[]

const SliceGRNLocation = createSlice({
  name: "SliceGRNLocation",
  initialState: { value: initialState },

  reducers: {
    GrnLocation_Set: (state, action) => {
      state.value = action.payload;
    },

    GrnLocation_Init: (state) => {
      state.value = initialState;
    }

  },
});

export const {
  GrnLocation_Set,
  GrnLocation_Init, 
} = SliceGRNLocation.actions;
export default SliceGRNLocation.reducer;
